// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SVqDx","col":"styles_col__MBoAe","actions":"styles_actions__HRBud","conflict":"styles_conflict__1Vbn6"};